import { Link } from "react-router-dom";

interface NewsItem {
  id: string;
  title: string;
  date: string;
  category: string;
  summary: string;
}

export default function LatestNews({ items }: { items: NewsItem[] }) {
  return (
    <ul className="flex flex-col divide-y divide-background-200">
      {items.map((item) => (
        <li key={item.id}>
          <Link to="/news" className="block py-4 first:pt-0 group cursor-pointer">
            <div className="flex items-center gap-2 mb-1.5">
              <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800 text-[11px] font-medium">
                {item.category}
              </span>
              <span className="text-xs text-foreground-500">{item.date}</span>
            </div>
            <h3 className="text-sm font-medium text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
              {item.title}
            </h3>
            <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2 leading-relaxed">
              {item.summary}
            </p>
          </Link>
        </li>
      ))}
    </ul>
  );
}